import {
  ACCOUNT,
  USER_ADMIN
} from './controllers'
import {
  URL_TRAINING,
  URL_CORPORATE,
  URL_EMPLOYMENT,
  URL_DOCUMENTS,
  URL_COMPANY_SECRETARY,
  URL_TEAMS,
  URL_FAQ,
  URL_USER_GUIDES,
  URL_RESTRUCTURING_INSOLVENCY
} from 'constants/links'

interface MenuItem {
  type: 'link' | 'group'
  title: string
  target?: string
  position: 'side' | 'solution' | 'side-bottom'
  params?: Record<string, string>
  disabled?: boolean
  requiresLogged?: boolean
  url?: string
  items?: Array<Omit<MenuItem, 'position'>>
  external?: boolean
  hideFromCore?: boolean
  activeClass?: string
  typeName?: string
  icon?: string
}

export const MENU_ITEMS: MenuItem[] = [
  { type: 'link', title: 'Team', url: URL_TEAMS, position: 'side', params: {}, external: true },
  { type: 'link', title: 'User Management', target: USER_ADMIN, position: 'side-bottom', params: {}, requiresLogged: true },
  { type: 'link', title: 'My Account', target: ACCOUNT, position: 'side-bottom', params: {}, requiresLogged: true },
  { type: 'link', title: 'FC Corporate', position: 'solution', url: URL_CORPORATE, external: true },
  { type: 'link', title: 'FC R&I', position: 'solution', url: URL_RESTRUCTURING_INSOLVENCY, external: true },
  { type: 'link', title: 'FC Employment', position: 'solution', url: URL_EMPLOYMENT, external: true },
  { type: 'link', title: 'FC Learning', position: 'solution', url: URL_TRAINING, external: true },
  { type: 'link', title: 'FC Documents', position: 'solution', url: URL_DOCUMENTS, external: true },
  { type: 'link', title: 'Company Secretary', position: 'solution', url: URL_COMPANY_SECRETARY, external: true },
  {
    type: 'group',
    title: 'Help',
    items: [
      { type: 'link', title: 'User Guides', url: URL_USER_GUIDES, external: true },
      { type: 'link', title: 'FAQ', url: URL_FAQ, params: {}, external: true }
    ],
    position: 'side'
  }
]
